import React from 'react';
import MaquetteSituation from './MaquetteSituation';
import { useOutletContext } from 'react-router-dom';
import Box from '@mui/material/Box';

export function LotMaquetteSituation() {
  const { lot, settings } = useOutletContext();

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        position: 'relative',
      }}
    >
      <MaquetteSituation
        infos={settings}
        lot={lot.key ? lot : { ...lot, key: lot.nom }}
        interactive={true}
      />
    </Box>
  );
}
